<template>
  <div class="home">
    <div class="container">
      <div class="mecca-live">
        <img
          class="z-10 w-full h-full object-cover"
          src="@/assets/images/main-mecca.png"
          alt=""
        />
        <div
          class="absolute bottom-0 left-0 right-0 h-[276px] bg-gradient-to-t from-black to-transparent"
        ></div>

        <div
          class="flex flex-col justify-between p-5 absolute w-full h-full top-0 left-0 right-0"
        >
          <div
            @click="() => $emit('open-live-streaming')"
            class="w-52 bg-white/50 backdrop-blur-[12px] rounded-full px-[15px] py-[11px] inline-flex items-center justify-start gap-[6px] cursor-pointer"
          >
            <span
              class="text-[#222222] text-[14px] leading-[18px] font-semibold"
            >
              Онлайн трансляция
            </span>
            <svg-icon name="live" class="" />
          </div>

          <div v-if="hajjDate" class="text-white mb-5">
            <div class="text-[20px] font-semibold">{{ hajjDateString }}</div>
            <div class="text-[15px] mt-3">Қажылыққа дейін</div>

            <CountDown :hajj-date="hajjDate" />
          </div>
        </div>
      </div>

      <div class="w-full flex flex-col gap-4">
        <HajjRegister />
        <HajjSearch />
      </div>
    </div>
  </div>

  <NewsSection />
  <VideosSection />
  <TourOperators />
  <HolyPlaces />
  <HajjMission />
  <Faq />
  <OurPartners />

  <MobileApps />
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";
import HajjRegister from "@/components/HajjRegister.vue";
import HajjSearch from "@/components/HajjSearch.vue";
import NewsSection from "@/components/NewsSection.vue";
import VideosSection from "@/components/VideosSection.vue";
import TourOperators from "@/components/TourOperators.vue";
import HolyPlaces from "@/components/HolyPlaces.vue";
import HajjMission from "@/components/HajjMission.vue";
import Faq from "@/components/Faq.vue";
import OurPartners from "@/components/OurPartners.vue";
import MobileApps from "@/components/MobileApps.vue";
import CountDown from "@/components/CountDown.vue";
import { geoService } from "@/services";
export default defineComponent({
  name: "HomeView",
  components: {
    SvgIcon,
    HajjRegister,
    HajjSearch,
    NewsSection,
    VideosSection,
    TourOperators,
    HolyPlaces,
    HajjMission,
    Faq,
    OurPartners,
    MobileApps,
    CountDown,
  },
  data() {
    return {
      hajjDate: null,
    };
  },
  computed: {
    hajjDateString() {
      if (!this.hajjDate) return null;
      const hajjDate = new Date(this.hajjDate);
      const month = hajjDate.toLocaleString("kk-KZ", { month: "long" });
      return `Қажылық ${hajjDate.getDate()} ${month.toLowerCase()} ${hajjDate.getFullYear()}ж`;
    },
  },
  mounted() {
    geoService.getHajjDate().then((response) => {
      if (response && response.date && new Date() < new Date(response.date)) {
        this.hajjDate = response.date;
      }
    });
  },
});
</script>

<style scoped lang="scss">
.home {
  @apply bg-[#F1F1F1];

  .container {
    @apply flex flex-col gap-4 md:flex-row-reverse;
  }

  .mecca-live {
    @apply h-[300px] sm:h-[400px] md:h-auto md:max-w-[500px] relative w-full rounded-[32px] overflow-hidden;
  }
}
</style>
